import { render, staticRenderFns } from "./search-other-brands.vue?vue&type=template&id=39c825cf&scoped=true"
import script from "./search-other-brands.vue?vue&type=script&lang=js"
export * from "./search-other-brands.vue?vue&type=script&lang=js"
import style0 from "./search-other-brands.vue?vue&type=style&index=0&id=39c825cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c825cf",
  null
  
)

export default component.exports